module.exports = __webpack_public_path__ + "assets/webgl/wp_dark_wall_color.85966d6b.jpg";